<template>
  <div class="card shadow-sm mb-4">
    <div v-if="!products.length" class="card-body">
      <h5>Tu carrito esta vacío</h5>
      <div>Agrega productos a tu carrito.</div>
    </div>
    <div v-else class="card-body">
      <div class="table-responsive-sm">
        <table class="table table-borderless table-middle">
          <tr
            v-for="product in products"
            :key="`${product.id}${hasVariationsSize(product.variations)}`"
            class="shadow-sm"
          >
            <td width="45" class="text-center">
              <button @click="removeItemCart(product)" type="button" class="close">&times;</button>
            </td>
            <td>
              <div class="form-row">
                <div class="col-auto">
                  <img width="110" :src="getImage(product)" alt="p" class="img-thumbnail" />
                </div>
                <div class="col">
                  <h4 class="product__title">{{ product.name }}</h4>
                  <div>
                    <div v-if="showVariations(product)">
                      <span
                        >{{ hasVariationsSize(product.variations).type }}:
                        <b>{{ hasVariationsSize(product.variations).content }}</b></span
                      >
                      <br />
                    </div>
                    SKU: <b>{{ product.sku.substring(0, 13) || product.id.substring(0, 13) }}</b
                    ><br />
                    Stock: <b>{{ stockVaritions(product) }}</b
                    ><br />
                    <div :class="isIntimo ? 'isSpecialPrice' : ''">
                      <span :class="{ decoration: product.offerPrice }">
                        Precio:
                        <b
                          >{{ product.currency || product.Currency | currency }}
                          {{ product.price }}</b
                        >
                      </span>
                      <div v-if="isIntimo" class="isSpecialPrice-text"><span>Intimo</span></div>
                    </div>
                    <span v-if="product.offerPrice">
                      Oferta:
                      <b> {{ product.currency | currency }} {{ product.offerPrice.toFixed(2) }} </b>
                    </span>
                  </div>
                </div>
                <div class="d-md-none mt-2">
                  <div class="text-center" width="150">
                    <CounterInput
                      v-model="product.quantity"
                      :limit="stockVaritions(product)"
                      disabled
                    />
                  </div>
                  <div class="lead text-right" width="150">
                    <b>{{ productsMeta.currency }} </b>
                    <b v-if="product.offerPrice">
                      {{ (product.quantity * product.offerPrice).toFixed(2) }}
                    </b>
                    <b v-else> {{ (product.quantity * product.price).toFixed(2) }} </b>
                  </div>
                </div>
              </div>
            </td>
            <td class="text-center d-none d-md-block" width="150">
              <CounterInput
                v-model="product.quantity"
                :limit="stockVaritions(product)"
                disabled
                v-if="!product.parentProductId"
              />
            </td>
            <td class="lead text-right d-none d-md-block" width="150">
              <b v-if="product.offerPrice">
                {{ productsMeta.currency }} {{ (product.quantity * product.offerPrice).toFixed(2) }}
              </b>
              <b v-else-if="isIntimo">
                {{ productsMeta.currency }}
                {{ (product.quantity * product.price).toFixed(2) }}
              </b>
              <b v-else>
                {{ productsMeta.currency }} {{ (product.quantity * product.price).toFixed(2) }}
              </b>
            </td>
          </tr>
        </table>
      </div>
      <div class="text-right" v-if="productsMeta.discount > 0">
        <p>
          <b>SubTotal: {{ productsMeta.currency }} {{ productsMeta.subtotal }}</b
          ><br />
          <b>Descuento: {{ productsMeta.currency }} -{{ productsMeta.discount }}</b>
        </p>
      </div>
      <div class="h3 text-right">
        <p>
          <b>Total: {{ productsMeta.currency }} {{ productsMeta.total }}</b>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ['isIntimo'],
  filters: {
    currency(value) {
      return value.symbol;
    }
  },
  data() {
    return {
      cartProducts: []
    };
  },
  computed: {
    products() {
      return this.$store.getters.cartProducts;
    },
    productsMeta() {
      return this.$store.getters.cartProductsMeta;
    },
    isDeliveryProccess() {
      return this.$store.getters.getIsDeliveryProccess;
    }
  },
  methods: {
    intimoPrice(product) {
      const { specialPrices, variations, stock } = product;
      const isArray = Array.isArray(specialPrices);
      if (isArray) {
        product.price = specialPrices[0].price;
        product.stock = variations != 0 ? variations.stock : stock;
      } else {
        const variant = specialPrices.intimo.find((elem) => elem.variationId == variations.id);
        product.price = variant.price;
        product.stock = variations.stock > 0 ? variations.stock : 0;
      }

      this.cartProducts.push(product);
    },
    showVariations(product) {
      return product.variationId ? true : false;
    },
    hasVariationsSize(value) {
      let size;
      if (value) {
        size = value.searchCode.split(':');
      } else {
        size = ['-', '-'];
      }
      const type = size[0];
      const content = size[1];
      return { type, content };
    },
    stockVaritions(value) {
      // if (this.isDeliveryProccess) {
      let stock;
      if (value.variationId) {
        stock = value.variations.stock;
      } else {
        stock = value ? value.stock : 0;
      }
      return Number(stock);
      // } else {
      //   return value.stock;
      // }
    },
    removeItemCart(product) {
      let idProduct;
      if (product.variations) {
        const size = product.variations.searchCode.split(':');
        idProduct = product.id + size[1];
      } else {
        idProduct = product.id;
      }
      this.$bvModal
        .msgBoxConfirm('¿Estás seguro de eliminar el producto?', {
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'SI',
          cancelTitle: 'NO',
          footerClass: 'p-2',
          hideHeaderClose: false
        })
        .then((value) => {
          if (value) {
            this.$store.commit('removeItemCartProducts', idProduct);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getImage(value) {
      const imgUrl = value.imageUrl || value.images.full.url;
      return imgUrl.includes('[]')
        ? imgUrl
        : imgUrl.includes('[{')
        ? JSON.parse(imgUrl)[0].imageurl
        : imgUrl;
    }
  },
  mounted() {
    if (this.isIntimo) {
      this.products.forEach((elem) => this.intimoPrice(elem));
    }
  }
};
</script>
